import posthog from "posthog-js";
import { isEmbedPath } from "@/utils/embedPath";

export function usePostHog() {
  const posthogKey = process.env.VUE_APP_POSTHOG_KEY;
  const posthogHost = process.env.VUE_APP_POSTHOG_HOST || "https://us.i.posthog.com";
  const isProduction = process.env.NODE_ENV === "production";

  // DL-452: PostHog is not initialised inside Horizon's iframe. Gating only the router's
  // $pageview left the worse half on: in production `disable_session_recording: !isProduction` is
  // false, so it records the user's session inside the iframe; `autocapture` defaults to true and
  // ships an event per click; and `persistence: "localStorage"` writes a distinct_id to the legacy
  // origin from a third-party frame. Horizon emits the embed's analytics.
  if (isEmbedPath()) {
    return { posthog: null };
  }

  // Return early if no PostHog key is configured
  if (!posthogKey) {
    console.warn("PostHog key not configured");
    return { posthog: null };
  }

  // Initialize PostHog if not already initialized
  if (!window.posthog) {
    try {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        person_profiles: "identified_only",
        capture_pageview: false,
        disable_session_recording: !isProduction,
        opt_out_capturing_by_default: false,
        cross_subdomain_cookie: false,
        secure_cookie: isProduction,
        persistence: "localStorage",
      });

      window.posthog = posthog;
    } catch (error) {
      console.error("PostHog initialization failed:", error);
      return { posthog: null };
    }
  }

  return { posthog: window.posthog };
}
